import { DispatchContext } from "../context.js";
import createFetch from "../../state/actions/createFetch.js";
import { useContext, useCallback } from 'react';
/** Build an imperative dispatcher to issue network requests. */

export default function useFetchDispatcher() {
  var throttle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var dispatch = useContext(DispatchContext);
  var fetchDispatcher = useCallback(function (fetchShape, params, body, updateParams) {
    var action = createFetch(fetchShape, {
      params: params,
      body: body,
      throttle: throttle,
      updateParams: updateParams
    });
    dispatch(action);
    return action.meta.promise;
  }, [dispatch, throttle]); // any is due to the ternary that we don't want to deal with in our implementation

  return fetchDispatcher;
}